/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ImportRouteImport } from './routes/import'
import { Route as LoginLinkRouteImport } from './routes/login-link'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as ShoppingRouteImport } from './routes/shopping'
import { Route as DevUiRouteImport } from './routes/dev.ui'
import { Route as InboxIndexRouteImport } from './routes/inbox.index'
import { Route as InboxIdRouteImport } from './routes/inbox.$id'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as RecipesIndexRouteImport } from './routes/recipes.index'
import { Route as RecipesIdRouteImport } from './routes/recipes.$id'
import { Route as RecipesNewRouteImport } from './routes/recipes.new'
import { Route as SettingsAiRouteImport } from './routes/settings_.ai'
import { Route as SettingsFriendsRouteImport } from './routes/settings_.friends'
import { Route as SettingsNotificationsRouteImport } from './routes/settings_.notifications'
import { Route as SettingsSlotsRouteImport } from './routes/settings_.slots'
import { Route as SettingsStaplesRouteImport } from './routes/settings_.staples'
import { Route as SettingsTokensRouteImport } from './routes/settings_.tokens'
import { Route as SettingsWhatsNewRouteImport } from './routes/settings_.whats-new'
import { Route as RecipesIdCookRouteImport } from './routes/recipes.$id_.cook'
import { Route as RecipesIdEditRouteImport } from './routes/recipes.$id_.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRoute = ImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLinkRoute = LoginLinkRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanRoute = PlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ShoppingRoute = ShoppingRouteImport.update({
  id: '/shopping',
  path: '/shopping',
  getParentRoute: () => rootRouteImport,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIdRoute = InboxIdRouteImport.update({
  id: '/inbox/$id',
  path: '/inbox/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIndexRoute = RecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIdRoute = RecipesIdRouteImport.update({
  id: '/recipes/$id',
  path: '/recipes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesNewRoute = RecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/settings_/ai',
  path: '/settings/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsFriendsRoute = SettingsFriendsRouteImport.update({
  id: '/settings_/friends',
  path: '/settings/friends',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings_/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSlotsRoute = SettingsSlotsRouteImport.update({
  id: '/settings_/slots',
  path: '/settings/slots',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStaplesRoute = SettingsStaplesRouteImport.update({
  id: '/settings_/staples',
  path: '/settings/staples',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/settings_/tokens',
  path: '/settings/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWhatsNewRoute = SettingsWhatsNewRouteImport.update({
  id: '/settings_/whats-new',
  path: '/settings/whats-new',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIdCookRoute = RecipesIdCookRouteImport.update({
  id: '/recipes/$id_/cook',
  path: '/recipes/$id/cook',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIdEditRoute = RecipesIdEditRouteImport.update({
  id: '/recipes/$id_/edit',
  path: '/recipes/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/import': typeof ImportRoute
  '/login-link': typeof LoginLinkRoute
  '/plan': typeof PlanRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/shopping': typeof ShoppingRoute
  '/dev/ui': typeof DevUiRoute
  '/inbox/$id': typeof InboxIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/recipes/$id': typeof RecipesIdRoute
  '/recipes/new': typeof RecipesNewRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/friends': typeof SettingsFriendsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/slots': typeof SettingsSlotsRoute
  '/settings/staples': typeof SettingsStaplesRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/settings/whats-new': typeof SettingsWhatsNewRoute
  '/inbox/': typeof InboxIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/recipes/$id/cook': typeof RecipesIdCookRoute
  '/recipes/$id/edit': typeof RecipesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/import': typeof ImportRoute
  '/login-link': typeof LoginLinkRoute
  '/plan': typeof PlanRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/shopping': typeof ShoppingRoute
  '/dev/ui': typeof DevUiRoute
  '/inbox/$id': typeof InboxIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/recipes/$id': typeof RecipesIdRoute
  '/recipes/new': typeof RecipesNewRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/friends': typeof SettingsFriendsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/slots': typeof SettingsSlotsRoute
  '/settings/staples': typeof SettingsStaplesRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/settings/whats-new': typeof SettingsWhatsNewRoute
  '/inbox': typeof InboxIndexRoute
  '/recipes': typeof RecipesIndexRoute
  '/recipes/$id/cook': typeof RecipesIdCookRoute
  '/recipes/$id/edit': typeof RecipesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/import': typeof ImportRoute
  '/login-link': typeof LoginLinkRoute
  '/plan': typeof PlanRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/shopping': typeof ShoppingRoute
  '/dev/ui': typeof DevUiRoute
  '/inbox/$id': typeof InboxIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/recipes/$id': typeof RecipesIdRoute
  '/recipes/new': typeof RecipesNewRoute
  '/settings_/ai': typeof SettingsAiRoute
  '/settings_/friends': typeof SettingsFriendsRoute
  '/settings_/notifications': typeof SettingsNotificationsRoute
  '/settings_/slots': typeof SettingsSlotsRoute
  '/settings_/staples': typeof SettingsStaplesRoute
  '/settings_/tokens': typeof SettingsTokensRoute
  '/settings_/whats-new': typeof SettingsWhatsNewRoute
  '/inbox/': typeof InboxIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/recipes/$id_/cook': typeof RecipesIdCookRoute
  '/recipes/$id_/edit': typeof RecipesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/import'
    | '/login-link'
    | '/plan'
    | '/settings'
    | '/setup'
    | '/shopping'
    | '/dev/ui'
    | '/inbox/$id'
    | '/invite/$token'
    | '/recipes/$id'
    | '/recipes/new'
    | '/settings/ai'
    | '/settings/friends'
    | '/settings/notifications'
    | '/settings/slots'
    | '/settings/staples'
    | '/settings/tokens'
    | '/settings/whats-new'
    | '/inbox/'
    | '/recipes/'
    | '/recipes/$id/cook'
    | '/recipes/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/import'
    | '/login-link'
    | '/plan'
    | '/settings'
    | '/setup'
    | '/shopping'
    | '/dev/ui'
    | '/inbox/$id'
    | '/invite/$token'
    | '/recipes/$id'
    | '/recipes/new'
    | '/settings/ai'
    | '/settings/friends'
    | '/settings/notifications'
    | '/settings/slots'
    | '/settings/staples'
    | '/settings/tokens'
    | '/settings/whats-new'
    | '/inbox'
    | '/recipes'
    | '/recipes/$id/cook'
    | '/recipes/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/import'
    | '/login-link'
    | '/plan'
    | '/settings'
    | '/setup'
    | '/shopping'
    | '/dev/ui'
    | '/inbox/$id'
    | '/invite/$token'
    | '/recipes/$id'
    | '/recipes/new'
    | '/settings_/ai'
    | '/settings_/friends'
    | '/settings_/notifications'
    | '/settings_/slots'
    | '/settings_/staples'
    | '/settings_/tokens'
    | '/settings_/whats-new'
    | '/inbox/'
    | '/recipes/'
    | '/recipes/$id_/cook'
    | '/recipes/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImportRoute: typeof ImportRoute
  LoginLinkRoute: typeof LoginLinkRoute
  PlanRoute: typeof PlanRoute
  SettingsRoute: typeof SettingsRoute
  SetupRoute: typeof SetupRoute
  ShoppingRoute: typeof ShoppingRoute
  DevUiRoute: typeof DevUiRoute
  InboxIdRoute: typeof InboxIdRoute
  InviteTokenRoute: typeof InviteTokenRoute
  RecipesIdRoute: typeof RecipesIdRoute
  RecipesNewRoute: typeof RecipesNewRoute
  SettingsAiRoute: typeof SettingsAiRoute
  SettingsFriendsRoute: typeof SettingsFriendsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsSlotsRoute: typeof SettingsSlotsRoute
  SettingsStaplesRoute: typeof SettingsStaplesRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  SettingsWhatsNewRoute: typeof SettingsWhatsNewRoute
  InboxIndexRoute: typeof InboxIndexRoute
  RecipesIndexRoute: typeof RecipesIndexRoute
  RecipesIdCookRoute: typeof RecipesIdCookRoute
  RecipesIdEditRoute: typeof RecipesIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-link': {
      id: '/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof LoginLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shopping': {
      id: '/shopping'
      path: '/shopping'
      fullPath: '/shopping'
      preLoaderRoute: typeof ShoppingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/$id': {
      id: '/inbox/$id'
      path: '/inbox/$id'
      fullPath: '/inbox/$id'
      preLoaderRoute: typeof InboxIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/': {
      id: '/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof RecipesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/$id': {
      id: '/recipes/$id'
      path: '/recipes/$id'
      fullPath: '/recipes/$id'
      preLoaderRoute: typeof RecipesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/new': {
      id: '/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof RecipesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/ai': {
      id: '/settings_/ai'
      path: '/settings/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof SettingsAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/friends': {
      id: '/settings_/friends'
      path: '/settings/friends'
      fullPath: '/settings/friends'
      preLoaderRoute: typeof SettingsFriendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/notifications': {
      id: '/settings_/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/slots': {
      id: '/settings_/slots'
      path: '/settings/slots'
      fullPath: '/settings/slots'
      preLoaderRoute: typeof SettingsSlotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/staples': {
      id: '/settings_/staples'
      path: '/settings/staples'
      fullPath: '/settings/staples'
      preLoaderRoute: typeof SettingsStaplesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/tokens': {
      id: '/settings_/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/whats-new': {
      id: '/settings_/whats-new'
      path: '/settings/whats-new'
      fullPath: '/settings/whats-new'
      preLoaderRoute: typeof SettingsWhatsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/$id_/cook': {
      id: '/recipes/$id_/cook'
      path: '/recipes/$id/cook'
      fullPath: '/recipes/$id/cook'
      preLoaderRoute: typeof RecipesIdCookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/$id_/edit': {
      id: '/recipes/$id_/edit'
      path: '/recipes/$id/edit'
      fullPath: '/recipes/$id/edit'
      preLoaderRoute: typeof RecipesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImportRoute: ImportRoute,
  LoginLinkRoute: LoginLinkRoute,
  PlanRoute: PlanRoute,
  SettingsRoute: SettingsRoute,
  SetupRoute: SetupRoute,
  ShoppingRoute: ShoppingRoute,
  DevUiRoute: DevUiRoute,
  InboxIdRoute: InboxIdRoute,
  InviteTokenRoute: InviteTokenRoute,
  RecipesIdRoute: RecipesIdRoute,
  RecipesNewRoute: RecipesNewRoute,
  SettingsAiRoute: SettingsAiRoute,
  SettingsFriendsRoute: SettingsFriendsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsSlotsRoute: SettingsSlotsRoute,
  SettingsStaplesRoute: SettingsStaplesRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  SettingsWhatsNewRoute: SettingsWhatsNewRoute,
  InboxIndexRoute: InboxIndexRoute,
  RecipesIndexRoute: RecipesIndexRoute,
  RecipesIdCookRoute: RecipesIdCookRoute,
  RecipesIdEditRoute: RecipesIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
